// extracted by mini-css-extract-plugin
module.exports = {"main":"Footer_main___7wug"};